import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  button: {
    marginTop: 16,
  },
  icon: {
    color: theme.palette.text.secondary,
    fontSize: 18,
    marginRight: 8,
  },
  linkIcon: {
    color: theme.palette.info.main,
    cursor: 'pointer',
    fontSize: 20,
    marginRight: 6,
  },
  media: {
    cursor: 'pointer',
    height: 0,
    paddingTop: '56.25%',
  },
  menu: {
    bottom: 12,
    position: 'absolute',
    right: 12,
  },
  root: {
    width: 368,
    overflow: 'inherit',
    position: 'relative',
  },
  title: {
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.secondary.main,
    },
  },
}));
